/**
 * @desc getUsers
 */
const URL = "/rantion-ucenter";
import http, { updateResponse } from "@/http";
export function request(body: defs.ucenter.UserRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/user/info`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
